import { ProductsApi } from "@api/products";
import { isLoading, isLoaded } from "@redux/action/loading";
import { useQuery } from "@tanstack/react-query";
import { useState, useEffect, useRef } from "react";

export const useSearchAllListQuery = ({
  initialPage = 1,
  isNumericSlug,
  queryPage,
}) => {
  const prevPageRef = useRef(initialPage);
  const page = queryPage || initialPage;
  const [totalPages, setTotalPages] = useState(0);

  const fetchAllProducts = async ({ queryKey }) => {
    const [_, queryPageNumber] = queryKey;

    // 현재 페이지를 저장
    prevPageRef.current = queryPageNumber;

    isLoading();

    try {
      const body = {
        modes: "AllListSet",
        page: queryPageNumber,
        page_rows: 20,
      };

      const res = await ProductsApi(body);

      if (res?.Code === "0000") {
        return res.Data.Data;
      } else {
        return { data: [], total_count: 0, total_page: 0 };
      }
    } catch (error) {
      console.error(error?.message);
      return { data: [], total_count: 0, total_page: 0 };
    } finally {
      isLoaded();
    }
  };

  const { data: productsData, isLoading: queryLoading } = useQuery({
    queryKey: ["products", page],
    queryFn: fetchAllProducts,
    enabled: isNumericSlug,
    keepPreviousData: false,
    staleTime: 0,
    // 쿼리가 중복으로 실행되는 것을 방지
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  // 총 페이지 수 계산
  useEffect(() => {
    if (productsData) {
      const calculatedTotalPages =
        productsData.total_page ||
        (productsData.total_count
          ? Math.ceil(productsData.total_count / 20)
          : 0);

      setTotalPages(calculatedTotalPages);
    }
  }, [productsData]);

  return {
    productsData,
    queryLoading,
    currentPage: page,
  };
};
